import { createSlice } from '@reduxjs/toolkit'

// Setup the initial state

const initialState = {
  getAuth: {},
  login: {},
  encryptPassword: {},
  user: {},
  misCode: '',
  logout: {},
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {

    // Log In the user

    setGetAuthLoading: (state) => {
      state.getAuth = {
        isLoading: true,
      };
    },

    setGetAuthSuccess: (state, action) => {
      state.getAuth = {
        data: action.payload
      };
    },

    setGetAuthFailure: (state, action) => {
      state.getAuth = {
        error: action.payload,
      }
    },

    setCleanUpGetAuthStore: (state) => {
      state.getAuth = {}
    },

    // Log In the user

    setLoginLoading: (state) => {
      state.login = {
        isLoading: true,
      };
    },

    setLoginSuccess: (state, action) => {
      state.login = {
        isLoggedIn: true
      };
      state.user = action.payload;
    },

    setLoginFailure: (state, action) => {
      state.login = {
        error: action.payload,
      }
    },

    setCleanUpLogInStore: (state) => {
      state.login = {}
    },

    // Store User Mis Code

    setMisCode: (state, action) => {
      state.misCode = action.payload
    },

    // Encrypt the user's password

    setEncryptPasswordLoading: (state) => {
      state.encryptPassword = {
        isLoading: true,
      };
    },

    setEncryptPasswordSuccess: (state, action) => {
      state.encryptPassword = {
        isEncrypted: true,
        data: action.payload,
      };
    },

    setEncryptPasswordFailure: (state, action) => {
      state.encryptPassword = {
        error: action.payload,
      }
    },

    // Logs out the user

    setLogOutLoading: (state) => {
      state.logout = {
        isLoading: true,
      };
    },

    setLogOutSuccess: (state) => {
      state.login = {};
      state.encryptPassword = {};
      state.user = {};
      state.misCode = '';
      state.logout = {};
    },

    setLogOutFailure: (state, action) => {
      state.logout = {
        error: action.payload,
      }
    },

  },
})

export const {
  setGetAuthLoading, setGetAuthSuccess, setGetAuthFailure, setCleanUpGetAuthStore,
  setLoginLoading, setLoginSuccess, setLoginFailure, setCleanUpLogInStore, setMisCode,
  setEncryptPasswordLoading, setEncryptPasswordSuccess, setEncryptPasswordFailure,
  setLogOutLoading, setLogOutSuccess, setLogOutFailure,
} = authSlice.actions

export default authSlice.reducer;